export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
            <path
                d="M14.7578 21.5527H23.6807M14.7578 31.3765H23.6807M27.7989 21.5527H36.7218M14.7578 26.5974H23.6807M27.7989 31.7179V27.2645C27.7989 26.8961 28.1062 26.5974 28.4853 26.5974H36.7218"
                stroke="#E7BD7C"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M43.4803 25.789C43.4803 35.6136 35.5378 43.5779 25.7401 43.5779C15.9425 43.5779 8 35.6136 8 25.789C8 15.9644 15.9425 8 25.7401 8C35.5378 8 43.4803 15.9644 43.4803 25.789Z"
                fill="#FDF6E8"
                stroke="url(#paint0_linear_289_16127)"
                strokeWidth="2"
            />
            <path
                d="M19.2505 21.5724L29.5633 17.3807C30.079 17.1711 30.6665 17.4229 30.8704 17.9408L32.3 21.5724M22.8495 25.863H25.5505M22.8495 28.6062H29.1505M35 24.3157V22.5724C35 22.0201 34.5523 21.5724 34 21.5724H18C17.4477 21.5724 17 22.0201 17 22.5724V24.3157C18.3495 24.3157 19.7 25.2298 19.7 27.0589C19.7 28.8881 18.3505 29.8022 17 29.8022V31.5454C17 32.0977 17.4477 32.5454 18 32.5454H34C34.5523 32.5454 35 32.0977 35 31.5454V29.8022C33.6505 29.8022 32.3 28.4301 32.3 26.8299C32.3 25.2298 33.6505 24.3157 35 24.3157Z"
                stroke="url(#paint1_linear_289_16127)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_289_16127" x1="25.7401" y1="8" x2="25.7401" y2="43.5779" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
                <linearGradient id="paint1_linear_289_16127" x1="34" y1="21.4199" x2="20" y2="31.9199" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="0.625003" stopColor="#CC9856" />
                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
            </defs>
        </svg>
    );
}
